import {
    COST_UNIT_TYPE_REORDERED,
    COST_UNIT_TYPE_SELECTED,
    COST_UNIT_TYPE_UNSELECTED,
    COST_UNIT_TYPES_LOADED,
    COST_UNIT_TYPES_SAVED,
    COST_UNIT_TYPES_SET,
    COST_UNIT_ROLES_LOADED,
    COST_UNIT_WARNINGS_LOADED,
    APPROVERS_TREE_ROOT_LOADED,
    APPROVERS_NODES_LOADED,
    COST_UNIT_ROLE_TYPES_LOADED,
    COST_UNITS_ROLES_SORT_CHANGED,
    CLOSE_COST_UNIT_NODE,
    DOCUMENT_TYPES_LOADED, COST_UNITS_BRANCHES_LOADED
} from "../store/actionTypes";
import * as Api from "utils/api/api";
import {handleError} from "utils/errorHandle.function";
import _ from "lodash";
import {getUsersCurrentContextId} from "components/store/application.reducers.js";


export function costUnitTypesLoaded(costUnitTypes) {
    return {
        type: COST_UNIT_TYPES_LOADED,
        data: costUnitTypes
    }
}

export function costUnitTypeSelected(costUnitTypes) {
    return {
        type: COST_UNIT_TYPE_SELECTED,
        data: costUnitTypes
    }
}

export function costUnitTypeUnselected(costUnitTypes) {
    return {
        type: COST_UNIT_TYPE_UNSELECTED,
        data: costUnitTypes
    }
}

export function costUnitTypeReordered(data) {
    return {
        type: COST_UNIT_TYPE_REORDERED,
        data
    }
}

export function costUnitTypesSet(costUnitTypes) {
    return {
        type: COST_UNIT_TYPES_SET,
        data: costUnitTypes
    }
}

export function costUnitTypesSaved() {
    return {
        type: COST_UNIT_TYPES_SAVED,
        data: {}
    }
}

export function costUnitRolesLoaded(id, level, roles = []) {
    return {
        type: COST_UNIT_ROLES_LOADED,
        data: roles,
        id: id,
        level: level
    }
}

export function costUnitWarningsLoaded(warnings = []) {
    return {
        type: COST_UNIT_WARNINGS_LOADED,
        data: warnings
    }
}

export function approversTreeRootLoaded(tree) {
    return {
        type: APPROVERS_TREE_ROOT_LOADED,
        data: tree
    }
}

export function costUnitsRoleTypesLoaded(roles = []) {
    return {
        type: COST_UNIT_ROLE_TYPES_LOADED,
        data: roles
    }
}


export function closeCostUnitNode(id) {
    return {
        type: CLOSE_COST_UNIT_NODE,
        data: id
    }
}

export function costUnitsBranchesLoaded(branches) {
    return {
        type: COST_UNITS_BRANCHES_LOADED,
        data: branches
    }
}


export function approversNodesLoaded(id, parentId, level, number, nodes = [], name = '') {
    return {
        type: APPROVERS_NODES_LOADED,
        id: id,
        data: nodes,
        name: name,
        parentId: parentId,
        level: level,
        number: number
    }
}

export function documentTypesLoaded(docTypes) {
    return {
        type: DOCUMENT_TYPES_LOADED,
        data: docTypes
    }
}


export function getCostUnitsData() {
    return function (dispatch) {
        dispatch(getDocumentTypesForWorkflowConfiguration());
        Api.getCostUnitTypes().then(costUnitTypes => {
            dispatch(costUnitTypesLoaded(costUnitTypes));
        }, error => {
            handleError(error);
        });
    }
}

export function setCostUnitsData(data, version) {
    return function (dispatch) {
        data.costUnits = data.costUnits.map((item) => {
            return {
                dimension: item.dimension,
                ordinal: item.ordinal
            }
        }, error => {
            handleError(error);
        });
        data.costUnits = JSON.stringify(data.costUnits);
        return Api.setCostUnitTypes(data, version);
    }
}

export function getCostUnitWarnings(companyId) {
    return function (dispatch) {
        Api.getDeletedCostUnitWarnings(companyId,{page: 1, rows: 100}).then(response => {
            dispatch(costUnitWarningsLoaded(response.rows));
        }, error => {
            handleError(error);
        });
    }
}

export function getApproversTreeRoot(companyId) {
    return function (dispatch) {
        return Api.getCostUnitNodes(companyId).then(root => {
            return Api.getCostUnitsCombinations(companyId, root.rootId, 1).then(response => {
                return dispatch(approversTreeRootLoaded(response));
            });
        });
    }
}

export function getApproversNodes(companyId, node, rootId) {
    return function (dispatch) {
        return Api.getCostUnitsCombinations(companyId, node.id, node.level, rootId).then(response => {
            if (response.nodes) {
                return dispatch(approversNodesLoaded(node.id, node.parent, node.level, node.number, response, node.name));
            }

            return Promise.resolve({});
        }, error => {
            handleError(error);
        });
    }
}

export function getCostUnitsRoles(companyId) {
    return function (dispatch) {
        Api.getRuleConfigurationRoles(companyId).then(response => {
            dispatch(costUnitsRoleTypesLoaded(response));
        }, error => {
            handleError(error);
        });
    }
}

export function getCostUnitsBranches(companyId) {
    return function (dispatch) {
        Api.getBranches(companyId).then(response => {
            dispatch(costUnitsBranchesLoaded(response));
        }, error => {
            handleError(error);
        });
    }
}

export function getDocumentTypesForWorkflowConfiguration() {
    return function (dispatch, getState) {
        const state = getState();
        const currentContextId = getUsersCurrentContextId(state);
        Api.getDocumentTypesForWorkflowConfiguration(currentContextId).then(response => {
            dispatch(documentTypesLoaded(response));
        }, error => {
            handleError(error);
        });
    }
}

export function getCostUnitRoles(companyId, costUnitId, level, sort) {
    return function (dispatch) {
        Api.getCostUnitRoles(companyId, costUnitId, level, sort.sortColumn, sort.sortOrder).then(response => {
            dispatch(costUnitRolesLoaded(costUnitId, level, response));
        }, error => {
            handleError(error);
        });
    }
}

export function saveNewCostUnitRole(companyId, costUnitId, roleId, userId, branchId, deputy, skip, costUnitLevel, sort) {
    return function (dispatch) {
        Api.saveNewCostUnitRole(companyId, costUnitId, roleId, userId, branchId, deputy, skip).then(response => {
            dispatch(getCostUnitRoles(companyId, costUnitId, costUnitLevel, sort));
        }, error => {
            handleError(error);
        });
    }
}

export function editCostUnitRole(companyId, costUnitId, roleId, userId, branchId, deputy, skip, oldRoleId, oldUserId, oldBranchId, costUnitLevel, sort) {
    return function (dispatch) {
        Api.editCostUnitRole(companyId, costUnitId, roleId, userId, branchId, deputy, skip, oldRoleId, oldUserId, oldBranchId).then(response => {
            dispatch(getCostUnitRoles(companyId, costUnitId, costUnitLevel, sort));
        }, error => {
            handleError(error);
        });
    }
}

export function deleteCostUnitRole(companyId, costUnitId, roleId, userId, branchId, costUnitLevel, sort) {
    return function (dispatch) {
        Api.deleteCostUnitRole(companyId, costUnitId, roleId, userId, branchId).then(response => {
            dispatch(getCostUnitRoles(companyId, costUnitId, costUnitLevel, sort));
        }, error => {
            handleError(error);
        });
    }
}

export function editSkippedCostUnitRole(companyId, costUnitId, roleId, userId, branchId, deputy, skip, oldRoleId, oldBranchId, costUnitLevel, sort) {
    return function (dispatch) {
        Api.editSkippedCostUnitRole(companyId, costUnitId, roleId, userId, branchId, deputy, skip, oldRoleId, oldBranchId).then(response => {
            dispatch(getCostUnitRoles(companyId, costUnitId, costUnitLevel, sort));
        }, error => {
            handleError(error);
        });
    }
}

export function deleteSkippedCostUnitRole(companyId, costUnitId, roleId, branchId, costUnitLevel, sort) {
    return function (dispatch) {
        Api.deleteSkippedCostUnitRole(companyId, costUnitId, roleId, branchId).then(response => {
            dispatch(getCostUnitRoles(companyId, costUnitId, costUnitLevel, sort));
        }, error => {
            handleError(error);
        });
    }
}

export function sortChanged(sort) {
    return {
        type: COST_UNITS_ROLES_SORT_CHANGED,
        sort: sort
    };

}

export function sortCostUnitRoles(companyId, sort, id, level) {
    return function (dispatch) {
        dispatch(sortChanged(sort));
        dispatch(getCostUnitRoles(companyId, id, level, sort));
    }

}

function getNodes(companyId, id, level, rootId) {
    return Api.getCostUnitsCombinations(companyId, id, level, rootId).then(response => {
        if (response.nodes) {
            return response;
        }

        return Promise.resolve();
    }, error => {
        handleError(error);
    });
}

export function getAllAncerstors(companyId, ancestors) {
    return function (dispatch) {
        //first get the root of the tree
        return getNodes(companyId, ancestors[0], 1).then(rootResponse => {
            dispatch(approversTreeRootLoaded(rootResponse));
            let nodes = Object.assign([], rootResponse.nodes);

            //parent is not in the root of the tree
            if (ancestors.length > 1 && rootResponse.nodes) {
                dispatch(loopAncestors(companyId, ancestors, 1, nodes));
            }

            return Promise.resolve();
        });
    }
}


function loopAncestors(companyId, ancestors, index, nodes) {
    return function (dispatch) {
        getNodes(companyId, ancestors[index], index + 1, ancestors[0]).then(response => {
            let currentNode = _.find(nodes, (node) => {
                return node.id === ancestors[index]
            });
            nodes = nodes.concat(response.nodes);
            dispatch(approversNodesLoaded(currentNode.id, currentNode.parent, currentNode.level, currentNode.number, response, currentNode.name));
            index += 1;

            if (index < ancestors.length) {
                dispatch(loopAncestors(companyId, ancestors, index, nodes));
            }
        });
    }
}
